import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { LoadingScreen } from '../../components/ui/LoadingScreen';
import { useAuthStore } from '../../stores/auth.store';

export function LoginCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { initialize } = useAuthStore();

  useEffect(() => {
    const token = searchParams.get('token');

    // Store the token in localStorage for API calls that need license info
    if (token) {
      localStorage.setItem('auth_token', token);
    }

    // Re-initialize auth state (will call Auth.Api with cookie)
    const completeLogin = async () => {
      await initialize();
      navigate('/', { replace: true });
    };

    completeLogin();
  }, [searchParams, navigate, initialize]);

  return <LoadingScreen message="Completing login..." />;
}
